import BlobBackground from './components/BlobBackground';
import BrandMark from './components/BrandMark';
import HeroTitle from './components/HeroTitle';
import TrustBadges from './components/TrustBadges';
import ProgressPreview from './components/ProgressPreview';
import CtaSection from './components/CtaSection';

const fadeSlideUp =
  'opacity-0 translate-y-6 animate-fade-slide-up';

export default function LandingPage() {
  return (
    <div className="relative min-h-screen bg-[#FBFAF7] flex flex-col items-center overflow-hidden">
      {/* Content wrapper — mobile frame */}
      <div className="relative z-10 w-full max-w-[430px] flex flex-col items-center px-6 pt-16 pb-8">

        {/* ====== Blob Background Layer ====== */}
        <BlobBackground />

        {/* ====== Brand — delayed 0ms ====== */}
        <div className={fadeSlideUp}>
          <BrandMark />
        </div>

        {/* ====== Hero — delayed 150ms ====== */}
        <div className={`${fadeSlideUp} mt-12`}>
          <HeroTitle />
        </div>

        {/* ====== Trust Badges — delayed 300ms ====== */}
        <div className={`${fadeSlideUp} mt-8`}>
          <TrustBadges />
        </div>

        {/* ====== Progress Preview — delayed 450ms ====== */}
        <div className={`${fadeSlideUp} mt-8`}>
          <ProgressPreview />
        </div>

        {/* ====== Disclaimer ====== */}
        <p
          className={`${fadeSlideUp} mt-6 text-xs text-[#55575D]`}
          style={{ animationDelay: '550ms' }}
        >
          응답은 맞춤 큐레이션에만 사용됩니다.
        </p>

        {/* ====== CTA — delayed 600ms ====== */}
        <div className={`${fadeSlideUp} mt-8 w-full`}>
          <CtaSection />
        </div>

      </div>
    </div>
  );
}